import request from '@/utils/request'

let Fposts_appApi = {

  /*帖子应用列表*/
  list(data) {
    return request._post('/shop/plus.fposts_app.Index/index', data);
},
/*添加帖子应用*/
add(data) {
    return request._post('/shop/plus.fposts_app.Index/add', data);
},
category_list(data) {
    return request._post('/shop/plus.fposts_app.Category/index', data);
},
category_add(data){
     return request._post('/shop/plus.fposts_app.Category/add', data);
},
category_delete(data){
     return request._post('/shop/plus.fposts_app.Category/delete', data);
},
editComment(data){
     return request._post('/shop/plus.fposts_app.PostComment/edit', data);
},
addComment(data){
     return request._post('/shop/plus.fposts_app.PostComment/add', data);
},
 approveComment(data){
     return request._post('/shop/plus.fposts_app.PostComment/approve', data);
 },
commentList(data){
     return request._post('/shop/plus.fposts_app.PostComment/index', data);
},
category_edit(data){
     return request._post('/shop/plus.fposts_app.Category/update', data);
},
/*修改帖子应用*/
edit(data) {
    return request._post('/shop/plus.fposts_app.Index/edit', data);
},
/*删除帖子应用*/
del(data) {
    return request._post('/shop/plus.fposts_app.Index/del', data);
},
/*帖子应用详情*/
detail(data) {
  return request._post('/shop/plus.fposts_app.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.fposts_app.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.fposts_app.Setting/getSetting', data, errorback);
    },
}
export default Fposts_appApi;



// WEBPACK FOOTER //
// ./src/api/fposts_app.js